/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Seg_FreelancerInputs */

const en_st_seg_freelancer = /** @type {(inputs: St_Seg_FreelancerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A freelancer`)
};

const id_st_seg_freelancer = /** @type {(inputs: St_Seg_FreelancerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freelancer`)
};

/**
* | output |
* | --- |
* | "A freelancer" |
*
* @param {St_Seg_FreelancerInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_seg_freelancer = /** @type {((inputs?: St_Seg_FreelancerInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Seg_FreelancerInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_seg_freelancer(inputs)
	return en_st_seg_freelancer(inputs)
});